import { render, staticRenderFns } from "./HomeSnippet.vue?vue&type=template&id=336ff3e4&scoped=true&"
import script from "./HomeSnippet.vue?vue&type=script&lang=text%2Fjavascript&"
export * from "./HomeSnippet.vue?vue&type=script&lang=text%2Fjavascript&"
import style0 from "./HomeSnippet.vue?vue&type=style&index=0&id=336ff3e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ff3e4",
  null
  
)

export default component.exports